import React from 'react'

export const About = () => {
    return (
        <div className="about-section">
            <div className="about-text animate__animated animate__fadeIn">
                <h1>About</h1>
                <p>
                The Last of Us Part II takes place five years after the events of the first game and nearly 25 years after the outbreak of the Cordyceps brain infection began. Ellie, who is now 19 years old, returns as the protagonist whom players assume control of. Joel, in his mid-fifties, also returns as a playable character, as does Abby Anderson, who functions as the game's false protagonist.
                </p>
                <p>
                Joel and Ellie, having settled down in Tommy's settlement, live in relative peace within the thriving community. While there, Ellie has even managed to form friendships with Dina and Jesse. However, the survivors face constant threats from infected and other hostile survivors.
                </p>
                <p>
                When a tragic event disrupts the tranquility of her life, a hate filled Ellie embarks on a journey to Seattle in a search for vengeance to carry out justice. As she hunts down those responsible one by one, she is confronted with the traumatizing physical and emotional consequences of her actions.
                </p>
            </div>
        </div>
    )
}
